// material ui
import { useTheme } from '@mui/material/styles';

export const ESGIcon = () => {
  const theme = useTheme();
  return (
    <img
      width="23"
      height="23"
      src="https://img.icons8.com/deco-glyph/48/hand-planting.png"
      alt="hand-planting"
      style={{
        filter: theme.palette.mode === 'dark' ? 'invert(100%)' : 'invert(40%)',
      }}
    />
  );
};
